<template>
  <div>
    <div class="text-left flex-display ai-center js-between">
      <h2 class="mg-less">เพิ่มแบบประเมินการเรียนออนไลน์</h2>
      <a
        @click="[resetFeedback(), (dialogFeedbackVisible = true)]"
        class="color-primary-light"
        >+ เพิ่มแบบประเมิน</a
      >
    </div>
    <div class="text-left pd-b-3  text-height-12">
      <span class="color-danger-light text-font-12 ">กรุณาเพิ่มแบบประเมิน ก่อนเพิ่มวิชาสุดท้ายภายในหลักสูตรนี้</span>
    </div>
    <div>
      <el-table
        v-if="showTable"
        :data="feedbackList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        empty-text="ไม่พบข้อมูล"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="หัวข้อแบบประเมินการเรียนออนไลน์"
          header-align="center"
          sortable
          :width="widthMax < 500.98 ? '170' : ''"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="ประเภทแบบประเมินการเรียนออนไลน์"
          :width="
            widthMax < 767.98
              ? '135'
              : widthMax < 1199
              ? '135'
              : widthMax > 1200
              ? '270'
              : ''
          "
          header-align="center"
          align="center"
          sortable
        >
          <template slot-scope="scope">{{
            typeof scope.row.type == 'undefined' || scope.row.type == 1?`คะแนน`:`ข้อความ${typeof scope.row.required !== 'undefined' && scope.row.required?' (บังคับกรอก)':''}`
          }}</template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '115'
              : widthMax < 1199
              ? '115'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="openEditFeddback(scope.row)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delFeedback(scope.row._id)"
                >
                  <div
                    slot="reference"
                    class="circle-action color-bg-danger-lighter"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title
      :visible.sync="dialogFeedbackVisible"
      :width="widthMax < 767.98 ? '90%' : widthMax < 991.98 ? '90%' : '60%'"
      top="10vh"
    >
      <div v-loading="loading">
        <div class="text-left pd-b-3 border-b">
          <h2 class="mg-less text-font-24 color-black">
            {{
              feedbackEdit == false
                ? "เพิ่มแบบประเมินการเรียนออนไลน์"
                : "แก้ไขแบบประเมินการเรียนออนไลน์"
            }}
          </h2>
        </div>
        <div class="text-left">
          <p class="text-font-16">
            <span class="color-black">ชื่อหลักสูตร: </span>
            <span class="color-gray">{{ courseName }}</span>
          </p>
        </div>
        <div v-if="dialogFeedbackVisible">
          <FeedbackForm
            @createFeedback="createFeedback"
            @updateFeedback="updateFeedback"
            :feedback="feedback"
            :type="feedbackEdit == false ? 'add' : 'update'"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import FeedbackForm from "@/components/feedback/FeedbackForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    FeedbackForm,
  },
  props: {
    feedbackList: {
      type: Array,
      defaut() {
        return [];
      },
    },
    courseName: {
      type: String,
      defaut() {
        return "";
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      dialogFeedbackVisible: false,
      feedbackEdit: false,
      loading: false,
      feedback: null,
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    delFeedback(id) {
      this.loading = true;
      let obj = {
        courseId: this.$route.query.courseId,
        assessmentId: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/assessment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchCouseById");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createFeedback(data) {
      this.loading = true;
      let obj = {
        courseId: this.$route.query.courseId,
        name: data.feedbackName,
        type: data.type,
        required:data.required
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`assessment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.dialogFeedbackVisible = false;
            this.$emit("fetchCouseById");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createFeedback error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateFeedback(data, id) {
      this.loading = true;
      let obj = {
        courseId: this.$route.query.courseId,
        assessmentId: id,
        name: data.feedbackName,
        type: data.type,
        required:data.required
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`assessment`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchCouseById");
            this.dialogFeedbackVisible = false;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateFeedback error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetFeedback() {
      this.feedbackEdit = false;
      this.feedback = null;
    },
    openEditFeddback(data) {
      this.feedback = data;
      this.dialogFeedbackVisible = true;
      this.feedbackEdit = true;
    },
  },
};
</script>